/**
 * Abstract cache adapter.
 *
 * @abstract
 */
class HttpCacheAbstractAdapter {
  /**
   * Constructor.
   *
   * @param {String} strategy
   */
  constructor(strategy) {
    this.strategy = strategy
  }

  /**
   * Tests to see if the adapter supports a given pool config instance.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {Boolean}
   */
  supports(poolConfig) {
    return poolConfig.strategy === this.strategy
  }

  /**
   * Loads all items for a cache pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {Array<HttpCacheItem>}
   */
  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  load(poolConfig) {
    throw new Error('Abstract method called')
  }

  /**
   * Saves all items for a cache pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @param {Array<HttpCacheItem>} cacheItems
   * @return {Boolean}
   */
  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  save(poolConfig, cacheItems) {
    throw new Error('Abstract method called')
  }
}

export default HttpCacheAbstractAdapter
